import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as ReactDOMClient from 'react-dom/client';
import * as JSXRuntime from 'react/jsx-runtime';

const mergedReactDOM = {
    ...ReactDOM,
    createRoot: ReactDOMClient.createRoot,
    hydrateRoot: ReactDOMClient.hydrateRoot,
};

// eslint-disable-next-line no-undef
window.ReactRuntime = {
    React,
    ReactDOM: mergedReactDOM,
    ReactDOMClient,
    JSXRuntime,
};

export { React, mergedReactDOM as ReactDOM, ReactDOMClient };
